import { bool, number, shape } from 'prop-types';
import React, { PureComponent } from 'react';

import { C, LAYOUT } from '../../common';
import { Motion, PictureCard } from '../../reactor/components';
import { THEME } from '../../reactor/common';
import Uri from '../Uri';
import styles from './CardStory.style';

const { AMPLITUDE: { CLICK_TYPE } } = C;
const { MOTION: { DURATION } } = THEME;

class CardStory extends PureComponent {
  static propTypes = {
    data: shape({}),
    index: number,
    visible: bool,
  };

  static defaultProps = {
    data: {},
    index: 0,
    visible: false,
  };

  render() {
    const { props: { data: { uri, sponsored, ...data }, index, visible } } = this;

    return (
      <Motion
        delay={visible ? (DURATION * 0.5) + ((DURATION * 0.1) * index) : 0}
        preset="fade"
        style={[styles.tile, sponsored && LAYOUT.STYLE.cardStoryContainer]}
        visible={visible}
      >
        <Uri eventProps={{ target: uri, type: CLICK_TYPE.LIST }} to={`/story/${uri}`}>
          <PictureCard
            {...data}
            portrait
            styleContainer={sponsored && LAYOUT.STYLE.cardStorySponsored}
            style={sponsored && LAYOUT.STYLE.cardStorySponsored}
          />
        </Uri>
      </Motion>
    );
  }
}

export default CardStory;
